import { registerSW } from 'virtual:pwa-register';

let needRefresh = false;
let updateSW: ((reloadPage?: boolean) => Promise<void>) | null = null;
const listeners = new Set<() => void>();

/**
 * Called once from main.tsx after createRoot(). Idempotent — repeat calls
 * are a no-op. Wires the vite-plugin-pwa virtual import to a tiny store
 * the UpdateBanner subscribes to.
 */
export function initPwaRegister(): void {
  if (updateSW !== null) return;
  updateSW = registerSW({
    onNeedRefresh() {
      needRefresh = true;
      listeners.forEach((fn) => fn());
    },
    onOfflineReady() {
      // No UI — drivers don't need to be told about offline-ready.
    },
  });
}

export function getNeedRefresh(): boolean {
  return needRefresh;
}

export function subscribe(fn: () => void): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}

/**
 * Activate the waiting service worker and reload the page.
 * Called from the UpdateBanner's Refresh button.
 */
export async function applyUpdate(): Promise<void> {
  if (updateSW) await updateSW(true);
}

/**
 * Test-only: reset module-level state between Vitest cases.
 * The Vitest globals.setupFiles infrastructure can't reach module-private
 * state, so consumers call this from `beforeEach`.
 */
export function __resetForTests(): void {
  needRefresh = false;
  updateSW = null;
  listeners.clear();
}
